import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProcessableOrders, getVendor } from "../../services/vendorService";
import { Vendor } from "../../interfaces/vendor";
import { ProcessableOrder } from "../../interfaces/order";
import ProcessOrdersConfirmation from "../../components/admin-components/ProcessOrdersConfirmation";

const ProcessOrders = () => {
  const { vendorID } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [vendor, setVendor] = useState<Vendor>();
  const [ordersList, setOrdersList] = useState<ProcessableOrder[]>([]);
  const [showProcessOrders, setShowProcessOrders] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (!vendorID) return;

        const numericVendorID = parseInt(vendorID, 10);

        const vendorResponse = await getVendor(numericVendorID);
        setVendor(vendorResponse);

        const ordersResponse = await getProcessableOrders(
          vendorResponse.vendorID,
        );
        setOrdersList(ordersResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessage("Error fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorID]);

  return (
    <div className="content-container">
      <div className="header-container">
        <h1>Process Orders - {vendor?.vendorName}</h1>
      </div>

      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          {vendor?.vendorID === 5 && (
            <div className="error">
              Remove middle name if different from current before processing
              additional names. (Candidates with additional names are red)
            </div>
          )}
          <div className="table-wrapper">
            <div className="table-container">
              <table className="table" style={{ cursor: "pointer" }}>
                <thead>
                  <tr>
                    <th style={{ width: "200px" }}>Client Name</th>
                    <th style={{ width: "200px" }}>Candidate Name</th>
                    <th style={{ width: "150px" }}>OrderID</th>
                    <th style={{ width: "150px" }}>Services</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.values(ordersList).length === 0 ? (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "center" }}>
                        No orders found.
                      </td>
                    </tr>
                  ) : (
                    Object.values(ordersList).map((order) => (
                      <tr
                        key={order.orderID}
                        onClick={() =>
                          navigate(`/admin/view-order/${order.orderID}`)
                        }
                      >
                        <td>{order.clientName}</td>
                        <td
                          className={`${order.additionalNames && vendor?.vendorID === 5 ? "error" : ""}`}
                        >
                          {order.candidateName}
                        </td>
                        <td>{order.orderID}</td>
                        <td>{Array.from(order.services).join(", ")}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <button
            className={`oxbtn btn-new ${
              Object.values(ordersList).length === 0 ? "disabled" : ""
            }`}
            onClick={() => setShowProcessOrders(true)}
            disabled={Object.values(ordersList).length === 0}
          >
            <div> PROCESS </div>
          </button>
          {showProcessOrders && vendor && (
            <ProcessOrdersConfirmation
              vendorID={vendor.vendorID}
              orders={ordersList}
              onClose={(success, message) => {
                setShowProcessOrders(false);
                setSuccessMessage(message || "");
                if (success) {
                  setOrdersList([]);
                }
              }}
            />
          )}
        </>
      )}

      {successMessage && (
        <div className="alert-message alert alert-success alert-dismissible fade show">
          {successMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setSuccessMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}
      {errorMessage && (
        <div
          className="alert-message alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}
    </div>
  );
};

export default ProcessOrders;
